import router from '../../router'
import {allowOnlyAuthorized} from '../../router/routeGuards'

import ImagePage from './ImagePage.vue'
import AppHeader from '../../components/layout/AppHeader'

// Setup routes
export default () => {
  router.addRoutes([
    {
      path: '/image/:imageId',
      name: 'image',
      components: {
        default: ImagePage,
        header: AppHeader,
      },
      beforeEnter: allowOnlyAuthorized()
    }
  ])
}
